import React from 'react';
import withRoot from '../../../withRoot';
import BaseGraph from '../base-graph'
import { horizontalBarDatasetOptions, horizontalBarOptions, horizontalBarPlugins } from '../constants'

class EventsPerOblastChart extends React.Component {
  render() {
    return (
      <BaseGraph
        type='horizontalBar'
        tableTitle="Average number of events per municipality per oblast"
        url='/graph/event_avg_community'
        chartOptions={horizontalBarOptions('number')}
        datasetOptions={horizontalBarDatasetOptions}
        filter={this.props.filter}
        plugins={horizontalBarPlugins('number')}
        noActions={this.props.noActions}
      />
    )
  }
}

export default withRoot(EventsPerOblastChart);
